<app-report-header />
<div class="main-container main-container--report" [ngClass]="{ full: innerWidth < 1000 }">
  <app-report-side-bar />
  <div class="content-container">
    <app-report-form (signature)="this.saveEmitter.emit($event)" />
  </div>
  @if (burgerOpen) {
    <div class="content-container" (click)="burgerOpen = false" [style.background-color]="'transparent'"></div>
  }
  <div class="action-container">
    <div class="left-container">
      <sag-ui-button color="secondary" (click)="goBack()">
        {{ "default.buttons.cancel" | translate }}
      </sag-ui-button>
      <sag-ui-button id="export-button" color="secondary" [disabled]="disableButtons" (click)="export()">
        {{ "default.buttons.print" | translate }}
      </sag-ui-button>
      @if (isAbleToSendToCeo) {
        <sag-ui-button id="sendEmail" color="secondary" [disabled]="disableButtons" (click)="sendMailToResponsible()">
          {{ "default.buttons.send" | translate }}
        </sag-ui-button>
      }
      @if (guard.isAdmin) {
        <input #fileUpload (change)="upload($event.target.files[0])" accept="application/pdf" class="file-input" style="display: none" type="file" />
        <sag-ui-button
          id="upload-button"
          color="secondary"
          sag-ui-tooltip
          [tooltip]="'report.actions.uploadReportManually' | translate"
          icon="upload"
          [square]="true"
          [disabled]="disableButtons"
          (click)="fileUpload.value = ''; fileUpload.click()">
        </sag-ui-button>
      }
    </div>
    <div class="right-container">
      @if (showButtons) {
        @if (activeSectionIndex > -1) {
          <sag-ui-button color="secondary" (click)="setActiveSection(activeSectionIndex - 1)">
            {{ "default.buttons.previous" | translate }}
          </sag-ui-button>
        }
        @if (activeSectionIndex !== sections?.length && activeSectionIndex >= -1) {
          <sag-ui-button color="secondary" (click)="setActiveSection(activeSectionIndex + 1)">
            {{ "default.buttons.next" | translate }}
          </sag-ui-button>
        }
      }
      @if (isAbleToEditAsSpecialist) {
        <sag-ui-button id="save-button" color="primary" [disabled]="disableButtons" (click)="saveEmitter.emit()">
          {{ "default.buttons.save" | translate }}
        </sag-ui-button>
      }
    </div>
  </div>
</div>
